import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { DELETE_COMMENT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import deleteComment from 'root/src/client/logic/comment/actions/deleteComment'

export default ({ listStoreKey, ...payload }) => async (dispatch) => {
	const { body, statusCode } = await dispatch(apiRequest(DELETE_COMMENT, payload))
	if (statusCode === 200) {
		dispatch(deleteComment({ ...body, listStoreKey }))
	}
}
